<template>
  <div class="scroll-container" ref="scrollContainer" @wheel.prevent="handleScroll">
    <div class="scroll-wrapper" ref="scrollWrapper" :style="{left: left + 'px'}" id="scrollMain">
      <slot></slot>
    </div>
  </div>
</template>

<script>
const padding = 2 // tag's padding

export default {
  name: 'scrollPane',
  data() {
    return {
      left: 0
    }
  },
  methods: {
    scrollToLeft(width) {
      // console.error(222, this.left, width)
      const w = this.left + parseFloat(width)
      if (w > 0) {
        this.left = 0
      } else {
        this.left = w
      }
      // console.error(333, this.left, w)
    },
    handleScroll(e) {
      const eventDelta = e.wheelDelta || -e.deltaY * 3
      const $container = this.$refs.scrollContainer
      const $containerWidth = $container.offsetWidth
      const $wrapper = this.$refs.scrollWrapper
      const $wrapperWidth = $wrapper.offsetWidth
      if (eventDelta > 0) {
        this.left = Math.min(0, this.left + eventDelta)
      } else {
        if ($containerWidth - padding < $wrapperWidth) {
          if (this.left < -($wrapperWidth - $containerWidth + padding)) {
            this.left = this.left
          } else {
            this.left = Math.max(this.left + eventDelta, $containerWidth - $wrapperWidth - padding)
          }
        } else {
          this.left = 0
        }
      }
    },
    moveToTarget($target) {
      const $container = this.$refs.scrollContainer
      const $containerWidth = $container.offsetWidth
      const $targetLeft = $target.offsetLeft
      const $targetWidth = $target.offsetWidth
      // console.error('moveToTarget', this.left, $containerWidth, $targetLeft, $targetWidth)
      if ($targetLeft < -this.left) {
        // console.error('left')
        // // tag in the left
        this.left = -$targetLeft + padding
      } else if ($targetLeft + padding > -this.left && $targetLeft + $targetWidth < -this.left + $containerWidth - padding) {
        // tag in the current view
        // eslint-disable-line
        // console.error('middle')
      } else {
        // tag in the right
        // console.error('right')
        this.left = -($targetLeft - ($containerWidth - $targetWidth) + padding)
        // console.error('right', this.left)
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.scroll-container {
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  /*width: 100%;*/
  margin-left: 65px;
  margin-right: 190px;
  .scroll-wrapper {
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollPane/index.vue